









import { Vue, Component, Prop } from "vue-property-decorator";
import { SvgIcon } from "@brankas/web-ui";
import { KYCStatus, KYCStatusMap } from "@/proto/identity/identity/all_pb";
import { kycApplicationLabel, kycApplicationType } from "@/utils/client-utils";

@Component({
  components: {
    SvgIcon,
  },
})
export default class KYCApplicationStatus extends Vue {
  @Prop({ default: KYCStatus.UNKNOWN_KYCSTATUS })
  applicationStatus!: KYCStatusMap[keyof KYCStatusMap];

  get applicationObject() {
    return kycApplicationLabel[this.applicationStatus];
  }

  get statusIcon() {
    return this.applicationObject.type === kycApplicationType.APPLYING
      ? "IconOutlinedCheck"
      : "IconOutlinedCross";
  }

  get statusClass() {
    let textColor = "";
    switch (this.applicationObject.type) {
      case kycApplicationType.NOT_APPLYING:
        textColor = "text-orange-400";
        break;
      case kycApplicationType.NOT_APPROVED:
        textColor = "text-red-300";
        break;
      default:
        textColor = "text-blue-300";
        break;
    }
    return textColor;
  }
}
